module.exports = __webpack_public_path__ + "img/preview.7fbfaa23.svg";